import React from 'react';

const ContactManagementAgency = () => (
  <div>
    <h1 className="h3 rec-questionnaire-result-what-you-need">
      You will need to...
    </h1>
    <div className="rec-questionnaire-result-title">
      Contact the Managing Agency
    </div>
    <p>
      Contact the managing agency of the area you are starting in. You will need a permit for the location where you are starting.
      Discuss with that agency if your permit also allows you access to the Inyo National Forest.
    </p>
  </div>
);

ContactManagementAgency.propTypes = {

};

export default ContactManagementAgency;
